exports.onClientEntry = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return
  }

  const cleanupServiceWorkers = async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(
        registrations.map(registration => registration.unregister()),
      )

      if (typeof caches !== "undefined") {
        const keys = await caches.keys()
        await Promise.all(keys.map(key => caches.delete(key)))
      }
    } catch {
      // no-op: cleanup best effort
    }
  }

  window.addEventListener("load", () => {
    cleanupServiceWorkers()
  })
}
